import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'

import style from './complete.sass'

@inject('store') @observer
class Complete extends Component {
  calculateHeight() {
    const containerOffset = this.container ? this.container.getBoundingClientRect().top : 0
    const about = document.querySelector('#about')
    const aboutHeight = about ? about.getBoundingClientRect().height : 0
    const footer = document.querySelector('footer')
    const footerHeight = footer ? footer.getBoundingClientRect().height : 0

    return window.innerHeight - containerOffset - aboutHeight - footerHeight
  }
  render() {
    const {complete, trialRequestComplete} = this.props.store.signup
    if (!complete && !trialRequestComplete) {
      return <Redirect to='/signup'/>
    }
    return(
      <div>
        <div styleName='banner'/>
        <section className='bg-white'>
          <div ref={el => this.container = el} className='landing-container' styleName='container' style={{minHeight: this.calculateHeight()}}>
            {complete
              ? <div>
                <h3>Sign Up complete</h3>
                <p>Please check your email address</p>
              </div>
              : <div>
                <h3>Your request is being processed</h3>
                <p>We will contact you soon</p>
              </div>
            }
          </div>
        </section>
      </div>
    )
  }
}

export default Complete
